import { useMemo } from 'react'
import { LabFeatureFlags } from 'constants/lab'
import { useLabFeatureFlag } from 'hooks/FeatureFlag/useLabFeatureFlag'
import { resolveLoyaltyCreditCardFeatureFlag } from 'loyalty/lib/loyaltyCreditCard/resolveLoyaltyCreditCardFeatureFlag'

export function useLoyaltyCreditCardFeatureFlag() {
  const flag = useLabFeatureFlag(LabFeatureFlags.societeCreditCardFlag)

  return useMemo(() => resolveLoyaltyCreditCardFeatureFlag(flag), [flag])
}
